export var name = 'rankingList';
export var AccumulationType;
(function (AccumulationType) {
    AccumulationType["NONE"] = "NONE";
    AccumulationType["DAILY"] = "DAILY";
    AccumulationType["WEEKLY"] = "WEEKLY";
    AccumulationType["GAME_ROUND"] = "GAME_ROUND";
})(AccumulationType || (AccumulationType = {}));
